@if (editLayerService.isEditing()) {
    @switch (detailPanelService.activeLayerType()) {
        @case (Layer.TypeEnum.TABLE) {
            <app-edit-deposit-layer />
        }
        @case (Layer.TypeEnum.INTERSTANDARD) {
            <app-edit-interstandard-layer />
        }
        @case (Layer.TypeEnum.REFERENCE_DATA) {
            <app-edit-deposit-layer />
        }
        @case (Layer.TypeEnum.WFS) {
            <app-edit-flux-layer />
        }
        @case (Layer.TypeEnum.WMS) {
            <app-edit-flux-layer />
        }
    }
} @else if (editLayerService.isEditingSymbology()) {
    <app-symbology-edit />
} @else {
    @switch (detailPanelService.activeLayerType()) {
        @case (Layer.TypeEnum.TABLE) {
            <app-deposit-layer-detail />
        }
        @case (Layer.TypeEnum.INTERSTANDARD) {
            <app-interstandard-layer-detail />
        }
        @case (Layer.TypeEnum.REFERENCE_DATA) {
            <app-deposit-layer-detail />
        }
        @case (Layer.TypeEnum.WFS) {
            <app-flux-layer-detail />
        }
        @case (Layer.TypeEnum.WMS) {
            <app-flux-layer-detail />
        }
    }
}
